import styled from 'styled-components'

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem 1.25rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 0.625rem 0.5rem;
    }
`

export default FormGrid
